import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-044a3d87")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Show Chart ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Clear selected countries ")
const _hoisted_4 = { class: "main-content" }
const _hoisted_5 = { class: "col-table col-content" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseThick = _resolveComponent("CloseThick")!
  const _component_ag_grid_vue = _resolveComponent("ag-grid-vue")!
  const _component_v_chart = _resolveComponent("v-chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      class: "input-search",
      type: "search",
      placeholder: "Search by Name, Region, Capital",
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onInput($event.target.value)))
    }, null, 32),
    _createElementVNode("button", {
      class: "show-btn",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getSelectedRows()))
    }, [
      _createVNode(_component_CloseThick, { style: {"margin-top":"2px"} }),
      _hoisted_2
    ]),
    (_ctx.selectedCountries.length > 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "clear-btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearSelected()))
        }, [
          _createVNode(_component_CloseThick, { style: {"margin-top":"2px"} }),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_ag_grid_vue, {
          style: _normalizeStyle([{ width: _ctx.tableWidth }, {"height":"600px"}]),
          class: "ag-theme-alpine center",
          columnDefs: _ctx.columnDefs,
          rowData: _ctx.rowData,
          rowSelection: "multiple",
          onGridReady: _ctx.onGridReady,
          pagination: true
        }, null, 8, ["style", "columnDefs", "rowData", "onGridReady"])
      ]),
      (_ctx.selectedCountries.length > 0)
        ? (_openBlock(), _createBlock(_component_v_chart, {
            key: 0,
            class: "col-content",
            option: _ctx.option
          }, null, 8, ["option"]))
        : _createCommentVNode("", true)
    ])
  ]))
}